<script setup lang="ts">
import Icon from './Icon.vue'
import TailoredOfferFooterBannerContact from './TailoredOfferFooterBannerContact.vue'
import useQuickOfferModalStore from '~/stores/modals/useQuickOfferModal'
import Container from '~/components/layout/Container.vue'

defineProps<{
  title: string
}>()

const quickOfferModalStore = useQuickOfferModalStore()
</script>

<template>
  <div class="c-tailored-offer-footer-banner">
    <Container class="c-tailored-offer-footer-banner__container">
      <h2 class="c-tailored-offer-footer-banner__title">
        {{ title }}
        <br />
        <br />
        {{ $t('tailoredOfferBanner.title') }}
      </h2>

      <div class="c-tailored-offer-footer-banner__main">
        <div class="c-tailored-offer-footer-banner__text">
          {{ $t('tailoredOfferBanner.description') }}
        </div>

        <div class="c-tailored-offer-footer-banner__contact">
          <TailoredOfferFooterBannerContact />
        </div>

        <div class="c-tailored-offer-footer-banner__button">
          <IButton
            class="has-icon"
            color="secondary"
            @click="quickOfferModalStore.open()"
          >
            {{ $t('tailoredOfferBanner.buttonText') }}

            <Icon name="arrow-right-thick" />
          </IButton>
        </div>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-tailored-offer-footer-banner {
  background-color: var(--color-solid-grey);
  padding: 132px 0;

  @include breakpoint-down('xl') {
    padding: 60px 0;
  }

  @include breakpoint-down('lg') {
    padding: 40px 0;
  }

  &__container {
    display: grid;
    grid-template-columns: 410px 1fr;
    gap: 60px;

    @include breakpoint-down('xl') {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  &__title {
    font-size: 40px;
    line-height: 1;

    @include breakpoint-down('lg') {
      font-size: 32px;
    }

    @include breakpoint-down('xs') {
      font-size: 28px;
    }
  }

  &__main {
    padding-top: 60px;
    border-top: 1px solid var(--color-border);
    display: grid;
    grid-template-columns: auto auto;
    gap: 40px 72px;

    @include breakpoint-down('xl') {
      padding-top: 30px;
    }

    @include breakpoint-down('lg') {
      grid-template-columns: 1fr;
      gap: 26px;
    }
  }

  &__text {
    font-size: 18px;
    line-height: 1.46;
  }

  &__button {
    :deep(.button) {
      --button--font-size: 18px;
      --button--padding-left: 36px;
      --button--padding-right: 36px;

      min-height: 64px;
      font-weight: 500;

      @include breakpoint-down('lg') {
        --button--font-size: 16px;
        --button--padding-left: 24px;
        --button--padding-right: 24px;
        min-height: 54px;
      }
    }
  }
}
</style>
